<div class="top-panel-wrapper">
    <div class="form form-horizontal">
        <div class="form-row">
            <div class="form-group mb-5">
                <label class="col-xs-9 control-label">
                    {{ "control_hide_behind_icon" | translate }}
                </label>
                <div class="col-xs-3 text-right">
                    <sp-switch [active]="hideContentOnMobile()" (toggleActiveEvent)="setHideContentOnMobile($event)" />
                </div>
            </div>
        </div>
    </div>
</div>

@if (hideContentOnMobile()) {
    <div class="tabs">
        <div class="tab" [class.active]="currentTab() === tabEnum.View" (click)="setCurrentTab(tabEnum.View)">
            {{ "control_tab_view" | translate }}
        </div>
        <div class="tab" [class.active]="currentTab() === tabEnum.Content" (click)="setCurrentTab(tabEnum.Content)">
            {{ "control_tab_content" | translate }}
        </div>
    </div>
}

@if (currentTab() === tabEnum.View) {
    <div class="panel-options-body overflow-wrapper">
        <div class="form form-horizontal">
            <div class="form-row">
                @if (hideContentOnMobile()) {
                    <div class="form-group mb-15">
                        <label class="col-xs-9 control-label">
                            {{ "control_background_color" | translate }}
                        </label>
                        <div class="col-xs-3">
                            <web-color-picker
                                [color]="backgroundColor()"
                                (colorChangeEvent)="setBackgroundColor($event)"
                            />
                        </div>
                    </div>

                    <div class="form-group mb-15">
                        <label class="col-xs-9 control-label">
                            {{ "control_text_color" | translate }}
                        </label>
                        <div class="col-xs-3">
                            <web-color-picker
                                [color]="textColor()"
                                [hideGradient]="true"
                                (colorChangeEvent)="setTextColor($event)"
                            />
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="col-xs-12">
                            {{ "control_position_and_style_icon" | translate }}
                        </label>
                        <div class="col-xs-10">
                            @let withCart = iconPositionType() === "header" && isCartEnabled();
                            <div class="btn-group d-flex">
                                <button
                                    class="btn btn-grey w-100"
                                    style="padding: 5px 12px"
                                    [class.active]="iconHorizontalPosition() === EHorizontalPosition.L"
                                    (click)="setIconHorizontalPosition(EHorizontalPosition.L)"
                                >
                                    <img
                                        [src]="
                                            withCart
                                                ? './assets/img/websites/cart/lpc-burger-with-cart-icon-l.svg'
                                                : './assets/img/websites/cart/lpc-burger-without-cart-icon-l.svg'
                                        "
                                        alt="Left"
                                    />
                                </button>
                                <button
                                    class="btn btn-grey w-100"
                                    style="padding: 5px 12px"
                                    [class.active]="iconHorizontalPosition() === EHorizontalPosition.R"
                                    (click)="setIconHorizontalPosition(EHorizontalPosition.R)"
                                >
                                    <img
                                        [src]="
                                            withCart
                                                ? './assets/img/websites/cart/lpc-burger-with-cart-icon-r.svg'
                                                : './assets/img/websites/cart/lpc-burger-without-cart-icon-r.svg'
                                        "
                                        alt="Right"
                                    />
                                </button>
                            </div>
                        </div>
                        <div class="col-xs-2">
                            <web-color-picker
                                [color]="iconColor()"
                                [hideGradient]="true"
                                (colorChangeEvent)="setIconColor($event)"
                            />
                        </div>
                    </div>

                    <div class="form-group mb-15">
                        <label class="col-xs-6 control-label">
                            {{ "control_size" | translate }}
                        </label>
                        <div class="col-xs-6">
                            <sp-radio-group
                                [selected]="iconSize()"
                                [type]="radioGroupType.size"
                                (changeSelectedEvent)="setIconSize($any($event))"
                            />
                        </div>
                    </div>

                    <div class="form-group mb-20">
                        <label class="col-xs-6">
                            {{ "control_padding" | translate }}
                        </label>

                        <div class="col-xs-12 d-flex">
                            <div class="d-flex align-items-center mr-5" style="flex-grow: 1">
                                <sp-input-num
                                    suffixText="px"
                                    [min]="PADDING_MIN"
                                    [max]="PADDING_MAX"
                                    [value]="padding()?.left"
                                    (valueChange)="setPadding('left', $event)"
                                />
                            </div>
                            <div style="flex-grow: 1">
                                <div class="mb-10">
                                    <sp-input-num
                                        suffixText="px"
                                        [min]="PADDING_MIN"
                                        [max]="PADDING_MAX"
                                        [value]="padding()?.top"
                                        (valueChange)="setPadding('top', $event)"
                                    />
                                </div>
                                <sp-input-num
                                    suffixText="px"
                                    [min]="PADDING_MIN"
                                    [max]="PADDING_MAX"
                                    [value]="padding()?.bottom"
                                    (valueChange)="setPadding('bottom', $event)"
                                />
                            </div>
                            <div class="d-flex align-items-center ml-5" style="flex-grow: 1">
                                <sp-input-num
                                    suffixText="px"
                                    [min]="PADDING_MIN"
                                    [max]="PADDING_MAX"
                                    [value]="padding()?.right"
                                    (valueChange)="setPadding('right', $event)"
                                />
                            </div>
                        </div>
                    </div>
                }

                <div class="form-group">
                    <label class="control-label col-xs-7">
                        {{ "control_align_content" | translate }}
                    </label>
                    <div class="col-xs-5">
                        <sp-radio-group
                            [selected]="horizontalPosition()"
                            [type]="radioGroupType.horizontalPosition"
                            (changeSelectedEvent)="setHorizontalPosition($any($event))"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
}

@if (currentTab() === tabEnum.Content) {
    <div class="panel-options-body overflow-wrapper">
        @if (!widgetToggles().length) {
            <div class="alert alert-info-mutted">
                {{ "block_without_widgets_message" | translate }}
            </div>
        }
        @for (widget of widgetToggles(); track widget.id) {
            <sp-control-handle
                controlHandleIcon="./assets/img/websites/lpc-{{ widget.name }}-icon.svg"
                controlHandleCheckbox
                [controlHandleBtn]="false"
                [controlHandleMainText]="widget.label | translate"
                [controlHandleSubText]="widget.subtext"
                [controlHandleCheckboxChecked]="widget.isVisible"
                (toggleCheckBoxEvent)="toggleWidget(widget.id, !widget.isVisible)"
            >
                <span cdkDragHandle></span>
            </sp-control-handle>
        }
    </div>
}
